import React, { useEffect, useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthContext from '../../Context/AuthContext';
import LanguageContext from '../../Context/LanguageContext';
import { useStorePath } from '../../lib/storefront/storePath';
import './AuthCallback.css';

const AuthCallback = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const storePath = useStorePath();
    const { t } = useTranslation();
    const { refreshUser } = useContext(AuthContext);
    const { currentLanguage } = useContext(LanguageContext);
    const [status, setStatus] = useState(t('authCallback.processing'));

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');
        const userRaw = params.get('user');

        if (!token || !userRaw) {
            setStatus(t('authCallback.missingData'));
            setTimeout(() => navigate(storePath(`/${currentLanguage || 'en'}/sign-in`), { replace: true }), 1500);
            return;
        }

        try {
            const user = JSON.parse(decodeURIComponent(userRaw));
            localStorage.setItem('token', token);
            if (user?.id) {
                localStorage.setItem('userId', user.id);
            }
            refreshUser();
            setStatus(t('authCallback.success'));
            setTimeout(
                () => navigate(storePath(`/${currentLanguage || 'en'}/profile`), { replace: true }),
                500,
            );
        } catch (err) {
            console.error('Failed to parse user from callback', err);
            setStatus(t('authCallback.error'));
            setTimeout(() => navigate(storePath(`/${currentLanguage || 'en'}/sign-in`), { replace: true }), 1500);
        }
    }, [location.search, navigate, refreshUser, currentLanguage, storePath, t]);

    return (
        <main className='auth-main'>
            <section className='auth-callback-section'>
                <div className='login-container container'>
                    <p className="auth-callback-status">{status}</p>
                </div>
            </section>
        </main>
    );
};

export default AuthCallback;
